import "./fonts.css"

export const fonts = {
  navbar: {
    fontFamily: "'Baloo Bhaina 2', cursive",
    fontWeight: 400,
  },
  headerUserName: {
    fontFamily: "'Amiri', serif",
    fontWeight: 400,
  },
  footerText: {
    fontFamily: "'Baloo Bhaina 2', cursive",
    fontWeight: 400,
  },
  categoryCard: {
    fontFamily: "'Baloo Bhaina 2', cursive",
    fontWeight: 400,
  },
  lora: {
    fontFamily: "'Lora', serif",
    fontWeight: 400,
  },
  mainPageText: {
    fontFamily: "'Baloo Bhaina 2', cursive",
    fontWeight: 400,
  },
}
